// gqlFragments.js
import gql from "graphql-tag";

export const FRAGMENT_USER_ALL_FIELDS = gql`
  fragment UserAllFields on User {
    id
    firstName
    lastName
    fullName
    role
    phone
    email
    unconfirmedEmail
    unconfirmedPhone
    avatar
    background
    licence
    aboutMe
    propertyTypes
    brokerName
    needUploadAgentDocuments
    specialties
    facebook
    linkedin
    agentSince
    brokerageAddress
    otherLicenses
    licenceApproved
    # pretiisCreditsAmount
    twillioIdentity
    refusedToBeLead
    showAnalytic
    isSeller
    canClaimProperty
    tcpaAccepted
    businessPhone
    brokeragePhone
    managingBrokerName
    brokerLicenseNumberAndState
    agentLocations {
      id
      description
      placeId
    }
    agentDocuments {
      id
      file
    }
    preferences {
      tagId
      title
      icon
      value
    }
    isochroneParams {
      lat
      lng
      value
      mode
    }
  }
`;

export const FRAGMENT_QUESTION = gql`
  fragment QuestionFields on Question {
    id
    tagId
    text
    questionType
    orderPosition
    needAnyValue
    required
    answersType
    questionsGroup
    answers {
      id
      text
      value
      orderPosition
      hint
      badge
      image
      cartoonImage
    }
  }
`;
